import isNil from 'lodash/isNil';

import { alpha } from '@mui/material/styles';

import determineIntegrationStatus from './determineIntegrationStatus';
import INTEGRATION_STATUS from './INTEGRATION_STATUS';

// The palette's `lighter` tones are not equally light (success and error are
// saturated), so every row tint is the `main` color at the same low opacity.
const ROW_TINT_OPACITY = 0.08;

// Color follows what the next deploy does: success turns the integration on, error turns it off.
const TINT_COLOR_BY_STATUS = {
  [INTEGRATION_STATUS.NOT_DEPLOYED]: 'success',
  [INTEGRATION_STATUS.STAGED_FOR_ACTIVATION]: 'success',
  [INTEGRATION_STATUS.STAGED_FOR_DELETE_ACTIVE]: 'error',
  [INTEGRATION_STATUS.STAGED_FOR_DELETE_PAUSED]: 'error',
  [INTEGRATION_STATUS.STAGED_FOR_PAUSE]: 'error',
  [INTEGRATION_STATUS.PAUSED]: 'warning',
};

export default function buildConditionalRowStyles(theme) {
  return [
    {
      when: row => !isNil(tintColor(row)),
      style: row => ({ backgroundColor: alpha(theme.palette[tintColor(row)].main, ROW_TINT_OPACITY) }),
    },
  ];
}

function tintColor(row) {
  return TINT_COLOR_BY_STATUS[determineIntegrationStatus(row)];
}
